import React from 'react';

const AlwaysIncluded = () => {
  return (
    <section className="bg-white py-16 px-4 sm:px-6 lg:px-8" id="inclusions">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-black mb-4">
          The G Adventures Difference
        </h2>

        <p className="text-lg sm:text-xl lg:text-2xl text-black mb-12">
          Founded in 1990 in Toronto, G Adventures is a proudly Canadian company that's been changing lives through travel for over 30 years. We believe in delivering authentic experiences while giving back to local communities.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white">
              <img
                className="w-24 h-24 mx-auto mb-4 object-cover"
                src={feature.image}
                alt={feature.title}
                width="90"
                height="90"
              />

              <h3 className="text-xl font-semibold text-black mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Core features of G Adventures tours
const features = [
  {
    title: 'Local Transportation',
    description: 'Experience authentic local transport, from tuk-tuks to trains, making your journey as memorable as the destination.',
    image: 'localTransport.jpg'
  },
  {
    title: 'Local Accommodation',
    description: 'Stay in carefully selected hotels, homestays, and unique lodgings that reflect the character of each destination.',
    image: 'localAccomodations.jpg'
  },
  {
    title: 'Local Experiences',
    description: 'Immerse yourself in authentic cultural experiences and activities, carefully curated by our local experts.',
    image: 'local.jpg'
  },
  {
    title: 'Expert CEOs',
    description: 'Travel with our Chief Experience Officers (CEOs) - passionate local guides who know their regions inside and out.',
    image: 'gceos.jpg'
  },
  {
    title: 'Small Groups',
    description: 'Travel with like-minded adventurers in small groups, typically 12-16 people, ensuring a more intimate experience.',
    image: 'small.jpg'
  },
  {
    title: 'Community Impact',
    description: "Support local communities through our G for Good projects, ensuring your travel has a positive impact on the places we visit.",
    image: 'impact.jpg'
  },
];

export default AlwaysIncluded;
